import { render, staticRenderFns } from "./withoutBanners.vue?vue&type=template&id=008d8090&scoped=true"
import script from "./withoutBanners.vue?vue&type=script&lang=js"
export * from "./withoutBanners.vue?vue&type=script&lang=js"
import style0 from "./withoutBanners.vue?vue&type=style&index=0&id=008d8090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d8090",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notification: require('/builds/gb-developers/geekbrains-client/components/global/Notification/Notification.vue').default})
